"use strict";
exports.__esModule = true;
var mapContent = require("../iana.json");
exports.map = mapContent;
//# sourceMappingURL=iana-aliases.js.map